import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Button,
    Card,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiCardContent from '@mui/material/CardContent';
import Footer from '../navbar/Footer';

const CardContent = styled(MuiCardContent)(`
  display: flex;
  flex-direction: row;
  padding: 16px;
`);

const oddData = [
    {
        title: "Rapport des Indicateurs de suivi de la mise en œuvre des Objectifs de Développement Durable (ODD), édition 2024",
        link: "/documents/IndicateursODD/RAPPORT_DES _INDICATEURS_ODD_2024.pdf",
        description: "",
        publicationDate: "2025-12-15",
        imageLink: 'assets/indicateursODD/Page_garde_indicateurs_ODD_2023.png',
    },
    {
        title: "Rapport d'actualisation des indicateurs de suivi de la mise en œuvre des objectifs de développement durable (ODD), édition 2023",
        link: "/documents/IndicateursODD/INSBU_Rapport_indicateurs_ODD_Final.pdf",
        description: "",
        publicationDate: "2024-12-15",
        imageLink: 'assets/indicateursODD/Page_garde_indicateurs_ODD_2023.png',
    },
    {
        title: "Rapport d'actualisation des indicateurs de suivi de la mise en œuvre des objectifs de développement durable (ODD), édition 2023",
        link: "/documents/IndicateursODD/INSBU_Rapport_indicateurs_ODD_Final.pdf",
        description: "",
        publicationDate: "2024-12-15",
        imageLink: 'assets/indicateursODD/Page_garde_indicateurs_ODD_2023.png',
    },
    {
        title: "Rapport d'actualisation des indicateurs de suivi de la mise en œuvre des objectifs de développement durable (ODD), édition 2022",
        link: "/documents/IndicateursODD/Rapport_ODD-2022-1.pdf",
        description: "",
        publicationDate: "2023-12-15",
        imageLink: 'assets/indicateursODD/rapport_actualisation_indicateur_ODD_2021.PNG',
    },
    {
        title: "Rapport d'actualisation des indicateurs de suivi de la mise en œuvre des objectifs de développement durable (ODD), édition 2021",
        link: "/documents/IndicateursODD/Rapport-actualisation-des-indicateurs-de-suivi-de-la-mise-en-oeuvre-des-ODD-Edition-2021.pdf",
        description: "",
        publicationDate: "2022-06-20",
        imageLink: 'assets/indicateursODD/rapport_actualisation_indicateur_ODD_2021_2023.PNG',
    },
    {
        title: "Brochure d'information sur les indicateurs de développement durable au Burundi",
        link: "/documents/IndicateursODD/Brochure-sur-les-Indicateurs-de-suivi-de-la-mise-en-oeuvre-des-ODD.pdf",
        description: "",
        publicationDate: "2020-05-10",
        imageLink: 'assets/indicateursODD/brochure_information_ODD.PNG',
    },
    {
        title: "Les indicateurs de suivi des objectifs de développement durable",
        link: "/documents/IndicateursODD/Indicateurs-de-Suivi-des-Objectifs-de-Développement-Durable.pdf",
        description: " ",
        publicationDate: "2019-03-25",
        imageLink: 'assets/indicateursODD/indicateur_suivi_odd.PNG',
    },
];

const ODDIndicators = () => {
    const [visibleCount, setVisibleCount] = useState(2);
    const [filterYear, setFilterYear] = useState('all');

    const getYear = (dateString) => new Date(dateString).getFullYear();

    const filteredData = filterYear === 'all'
        ? oddData
        : oddData.filter(item => getYear(item.publicationDate) === parseInt(filterYear, 10));

    const years = [...new Set(oddData.map(item => getYear(item.publicationDate)))];
    years.sort((a, b) => b - a);

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + 2);
    };

    const handleFilterChange = (event) => {
        setFilterYear(event.target.value);
        setVisibleCount(2);
    };

    const cardStyle = {
        marginBottom: '10px',
        border: '1px solid #ddd',
        borderRadius: '5px',
    };

    const imageStyle = {
        width: '80px',
        height: 'auto',
        marginRight: '20px',
        borderRadius: '5px',
        display: 'block',
    };

    const contentStyle = {
        flex: '1',
    };

    const menuItemStyle = {
        color: 'green',
    };

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '10px' }}>
            <NavigationBar />
            <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
                <Typography variant="h6" align="justify" gutterBottom>
                    Les objectifs de développement durable (ODD)
                </Typography>
                <Typography variant="body1" align="justify" paragraph>
                    Cette section met en lumière les rapports et documents en lien avec les Objectifs de Développement Durable (ODD).
                    Le rapport d'actualisation des indicateurs ODD résulte des efforts collaboratifs du Comité multisectoriel dédié à la
                    surveillance des indicateurs de mise en œuvre des programmes de développement, incluant les ODD et le Plan National
                    de Développement (PND), tout ceci avec le soutien financier du Programme des Nations Unies pour le Développement (PNUD).
                    Cette actualisation annuelle fournit au Gouvernement des données précieuses pour ajuster efficacement sa politique
                    en vue d'atteindre la vision 2030.
                </Typography>

                <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px' }}>
                    <InputLabel id="year-filter-odd-label">Sélectionnez par l'année de publication (ODD)</InputLabel>
                    <Select
                        labelId="year-filter-odd-label"
                        id="year-filter-odd"
                        value={filterYear}
                        label="Sélectionnez par l'année de publication (ODD)"
                        onChange={handleFilterChange}
                    >
                        <MenuItem value="all">Tous les indicateurs (ODD)</MenuItem>
                        {years.map(year => (
                            <MenuItem key={year} value={year} style={menuItemStyle}>{year}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {filteredData.slice(0, visibleCount).map((document, index) => (
                    <Card key={index} style={cardStyle}>
                        <CardContent>
                            <a href={document.link} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'flex-start', textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    <img src={document.imageLink} alt={document.title} style={imageStyle} />
                                </Box>
                            </a>
                            <Box style={contentStyle}>
                                <a href={document.link} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'flex-start', textDecoration: 'none', color: 'inherit' }}>
                                    <Typography variant="h6" component="div" style={{ color: 'green' }}>
                                        <DownloadIcon /> {document.title}
                                    </Typography>
                                </a>
                                <Typography variant="body2" color="textSecondary">
                                    {document.description}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                ))}

                {visibleCount < filteredData.length && (
                    <Button
                        onClick={handleLoadMore}
                        style={{
                            marginTop: '20px',
                            backgroundColor: '#388E3C',
                            color: 'white',
                        }}
                    >
                        Plus d'indicateurs (ODD)
                    </Button>
                )}
            </Container>
            <br />
            <br />
            <Footer />
        </div>
    );
};

export default ODDIndicators;